import { Path } from 'urlBuilder';

export const excludedPaths: string[] = [Path.customerDecision];
